import { render } from "./TradePassportSpecialism.vue?vue&type=template&id=1f7040d9&scoped=true&ts=true"
import script from "./TradePassportSpecialism.vue?vue&type=script&lang=ts"
export * from "./TradePassportSpecialism.vue?vue&type=script&lang=ts"

import "./TradePassportSpecialism.vue?vue&type=style&index=0&id=1f7040d9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7040d9"]])

export default __exports__